import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

import { StyledConversationThumbnail } from "../ConversationThumbnail/styled";

export const StyledAttachmentContainer = styled.div<{ $isFromMe: boolean }>`
    max-width: 100%;
    margin-top: 12px;

    ${StyledConversationThumbnail} {
        flex: 0 0 auto;
        margin-right: 4px;
    }

    .attachments-subcontainer {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        min-height: 88px;
        overflow-x: auto;
        cursor: pointer;

        div {
            position: relative;
            height: 88px;
            margin-left: 4px;
        }

        @media ${breakpoints.xs} {
            flex-wrap: wrap;
        }
    }

    ${(props) =>
        props.$isFromMe &&
        `
        justify-content: flex-end;

        ${StyledConversationThumbnail} {
            margin-right: 0;
        }


        `}
`;
